// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserRagUpload .base-card {
  border-radius: 8px;
}
#AdminUserRagUpload .List .list-row {
  height: fit-content;
}
#AdminUserRagUpload .List .listitem {
  padding: 16px 8px;
}
#AdminUserRagUpload .list-area {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
#AdminUserRagUpload .middle-button {
  max-width: 15%;
}
#AdminUserRagUpload .long-button {
  max-width: 20%;
}
#AdminUserRagUpload .vlong-button {
  max-width: 25%;
}
#AdminUserRagUpload .addmergin {
  margin-top: 32px;
  padding-bottom: 32px;
}
#AdminUserRagUpload .operate-button {
  position: relative;
  padding: 0;
  min-height: 28px;
  max-height: 28px;
  min-width: 72px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s color 0.3s border 0.3s;
}
#AdminUserRagUpload .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserRagUpload .operate-button.danger:hover {
  background-color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  color: var(--white-color-lightest);
}
#AdminUserRagUpload .operate-button.primary {
  background-color: var(--primary-color-main);
  border: 1px solid var(--primary-color-main);
  color: var(--white-color-lightest);
}
#AdminUserRagUpload .operate-button.primary:hover {
  background-color: var(--primary-color-dark);
  color: var(--white-color-lightest);
}
#AdminUserRagUpload .operate-button:disabled, #AdminUserRagUpload .operate-button.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: var(--disabled-bg-color);
  color: var(--disabled-font-color);
  pointer-events: none;
}
#AdminUserRagUpload .operate-button .operate-label {
  height: 24px;
}
#AdminUserRagUpload .operate-button .train-spinner {
  --base-size: 14px;
  --loading-color: currentColor;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
#AdminUserRagUpload .operate-button .train-spinner .half-circle-spinner .circle {
  border-width: 2px;
}
#AdminUserRagUpload .input-label-text {
  text-align: left;
}
#AdminUserRagUpload .operate-area {
  width: 60%;
}
#AdminUserRagUpload .operate-area .operate-button {
  width: 180px;
  padding: 8px 4px;
  min-height: 28px;
  max-height: 28px;
  min-width: 120px;
}
#AdminUserRagUpload .rag-update-modal-content .chunk-option-container {
  margin-top: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  padding: 8px 16px;
  border-radius: 4px;
  width: fit-content;
}
#AdminUserRagUpload .rag-update-modal-content .note-text {
  font-size: 0.85rem;
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserRagUpload.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAIQ;EACI,mBAAA;AAFZ;AAKQ;EACI,iBAAA;AAHZ;AAOI;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AALR;AAQI;EACI,cAAA;AANR;AAQI;EACI,cAAA;AANR;AAQI;EACI,cAAA;AANR;AASI;EACI,gBAAA;EACA,oBAAA;AAPR;AAUI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,wDAAA;AATR;AAWQ;EACI,wCAAA;EACA,8BAAA;AATZ;AAaY;EACI,0CAAA;EACA,0CAAA;EACA,kCAAA;AAXhB;AAcQ;EACI,2CAAA;EACA,2CAAA;EACA,kCAAA;AAZZ;AAcY;EACI,2CAAA;EACA,kCAAA;AAZhB;AAiBQ;EACI,8CAAA;EACA,0CAAA;EACA,iCAAA;EACA,oBAAA;AAfZ;AAkBQ;EACI,YAAA;AAhBZ;AAoBQ;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AAlBZ;AAoBY;EACI,iBAAA;AAlBhB;AAuBI;EACI,gBAAA;AArBR;AAwBI;EACI,UAAA;AAtBR;AAwBS;EACG,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAtBZ;AA2BQ;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAzBZ;AA4BQ;EACI,kBAAA;EACA,WAAA;AA1BZ","sourcesContent":["#AdminUserRagUpload{\n    .base-card{\n        border-radius: 8px;\n    }\n\n    .List{\n        .list-row {\n            height: fit-content;\n        }\n\n        .listitem{\n            padding: 16px 8px;\n        }\n    }\n\n    .list-area{\n        max-height: 400px;\n        overflow-x: hidden;\n        overflow-y: auto;\n    }\n\n    .middle-button{\n        max-width: 15%\n    }\n    .long-button{\n        max-width: 20%\n    }\n    .vlong-button{\n        max-width: 25%\n    }\n\n    .addmergin{\n        margin-top: 32px;\n        padding-bottom: 32px;\n    }\n\n    .operate-button{\n        position: relative;\n        padding: 0;\n        min-height: 28px;\n        max-height: 28px;\n        min-width: 72px;\n        border-radius: 14px;\n\n        border: 1px solid var(--border-weak-color);\n        background-color: var(--white-color-lightest);\n        transition: background-color 0.3s color 0.3s border 0.3s;\n\n        &:hover{\n            background-color: var(--dark-color-main);\n            color: var(--white-color-main);\n        }\n\n        &.danger{\n            &:hover{\n                background-color: var(--danger-color-main);\n                border: 1px solid var(--danger-color-main);\n                color: var(--white-color-lightest);\n            }\n        }\n        &.primary{\n            background-color: var(--primary-color-main);\n            border: 1px solid var(--primary-color-main);\n            color: var(--white-color-lightest);\n\n            &:hover{\n                background-color: var(--primary-color-dark);\n                color: var(--white-color-lightest);\n            }\n        }\n\n        // 押せないとき(学習中など)は非活性の見た目にする(primary・danger より後に置いて上書きする)\n        &:disabled, &.disabled{\n            border: 1px solid var(--disabled-border-color);\n            background-color: var(--disabled-bg-color);\n            color: var(--disabled-font-color);\n            pointer-events: none;\n        }\n\n        .operate-label{\n            height: 24px;\n        }\n\n        // 待機中・学習中にボタンの左端で回す(文字の中央寄せは崩さない。色はボタンの文字色に合わせる)\n        .train-spinner{\n            --base-size: 14px;\n            --loading-color: currentColor;\n            position: absolute;\n            left: 10px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .half-circle-spinner .circle{\n                border-width: 2px;\n            }\n        }\n    }\n\n    .input-label-text {\n        text-align: left;\n    }\n\n    .operate-area {\n        width: 60%;\n\n         .operate-button {\n            width: 180px;\n            padding: 8px 4px;\n            min-height: 28px;\n            max-height: 28px;\n            min-width: 120px;\n        }\n    }\n\n    .rag-update-modal-content {\n        .chunk-option-container {\n            margin-top: 8px;\n            margin-bottom: 8px;\n            border: 1px solid #ccc;\n            padding: 8px 16px;\n            border-radius: 4px;\n            width: fit-content;\n        }\n\n        .note-text {\n            font-size: 0.85rem;\n            color: #888;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
